import React from "react";
import AccessDenied from "../pages/Accounts/AccessDenied";
import { useAuth } from "../context/AuthContext";

const ProtectedAdminRoute = ({
  children,
  allowedRoles = ["admin", "cashier"],
  title,
  message,
}) => {
  const { loading, session, role, isSupabaseConfigured } = useAuth();

  if (!isSupabaseConfigured) {
    return children;
  }

  if (loading) {
    return (
      <div className="container py-8">
        <div className="alert alert-light border mb-0">Chargement de l'administration...</div>
      </div>
    );
  }

  if (!session) {
    return (
      <AccessDenied
        title="Connexion requise"
        message="Vous devez vous connecter avec un compte autorise pour acceder a cette page."
        showSignIn
      />
    );
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return (
      <AccessDenied
        title={title || "Acces refuse"}
        message={
          message || "Votre compte n'a pas les permissions necessaires pour acceder a cette page."
        }
      />
    );
  }

  return children;
};

export default ProtectedAdminRoute;
